module.exports = __webpack_public_path__ + "static/predictivepoem 45-01-33ee64fcc30e1505f13aad01312daad4.jpg";